import React from "react";
import { Route, Switch } from "react-router-dom";
import AppliedRoute from "components/router/AppliedRoute";
import AuthenticatedRoute from "components/router/AuthenticatedRoute";
import UnauthenticatedRoute from "components/router/UnauthenticatedRoute";
import RoleRoute from "components/router/RoleRoute";

import Home from "containers/Home";
import Login from "containers/Login/index";
// import Signup from "containers/Signup";
// import Forgot from "containers/Forgot";
import CAS from "containers/CAS";
import RequestList from "containers/request/RequestList/index";
import Approve from "containers/Approve";
import RequestNew from "containers/request/RequestNew";
import InitialSubmitPage from "containers/request/Initial/InitialSubmitPage";
import RequestPage from "containers/request/Initial/RequestPage";
// import VariantRequest from "containers/request/Variant";
import EcoSubmitPage from "containers/request/ECO/EcoSubmitPage";
import CertifiedDevices from "containers/Devices/index";
import CertifiedDeviceView from "containers/Devices/CertifiedDevice";
import TestLabs from "containers/Labs";
import TestRequestList from "containers/request/TestRequestList/index";
import TestResultsList from "containers/TestResultsList";
import TestResultsItem from "containers/TestResultsItem";
// import Test from "containers/Test";
import FCCID from "containers/FCCID";
import NotFound from "containers/NotFound";
import Payments from "containers/request/Payments/index";
import AddPayment from "containers/request/Payments/AddPayment";
// import RebrandSubmitPage from "containers/request/Rebrand/RebrandSubmitPage";

import roles from 'dictionaries/UserRoles';

export default ({ childProps }) =>
    <Switch>
        {/* home page route */}
        <AppliedRoute path="/" exact component={CAS} props={childProps} />
        <AppliedRoute path="/home" exact component={Home} props={childProps} />
        
        {/* un-auth user routes */}
        <UnauthenticatedRoute path="/login" exact component={Login} props={childProps} />
        {/* <UnauthenticatedRoute path="/signup" exact component={Signup} props={childProps} /> */}
        {/* <UnauthenticatedRoute path="/forgot" exact component={Forgot} props={childProps} /> */}
        <UnauthenticatedRoute path="/cas" exact component={CAS} props={childProps} />
        
        {/* manufacturer-only user routes */}
        <RoleRoute path="/requests" exact component={RequestList} props={childProps} role={roles.vendor} />
        <RoleRoute path="/requests/:id" exact component={RequestPage} props={childProps} role={roles.vendor} />
        <RoleRoute path="/request/new" exact component={RequestNew} props={childProps} role={roles.vendor} />
        <RoleRoute path="/request/new/initial" exact component={InitialSubmitPage} props={childProps} role={roles.vendor} />
        <RoleRoute path="/request/new/eco" exact component={EcoSubmitPage} props={childProps} role={roles.vendor} />
        {/* <RoleRoute path="/request/new/rebrand" exact component={RebrandSubmitPage} props={childProps} role={roles.vendor} /> */}
        {/* <RoleRoute path="/request/new/variant" exact component={VariantRequest} props={childProps} role={roles.vendor} /> */}

        {/* lab-only user routes */}
        <RoleRoute path="/lab/requests" exact component={TestRequestList} props={childProps} role={roles.lab} />
        <RoleRoute path="/lab/requests/:id" exact component={RequestPage} props={childProps} role={roles.lab} />
        <RoleRoute path="/lab/results" exact component={TestResultsList} props={childProps} role={roles.lab} />
        <RoleRoute path="/lab/results/:id" exact component={TestResultsItem} props={childProps} role={roles.lab} />

        {/* staff-only user routes */}
        <RoleRoute path="/admin/requests" exact component={RequestList} props={childProps} role={roles.staff} />
        <RoleRoute path="/admin/approval" exact component={Approve} props={childProps} role={roles.staff} />
        <RoleRoute path="/admin/requests/:id" exact component={RequestPage} props={childProps} role={roles.staff} />

        {/* accountant-only routes */}
        <RoleRoute path="/payments" exact component={Payments} props={childProps} role={roles.accountant} />
        <RoleRoute path="/payments/:id/add" exact component={AddPayment} props={childProps} role={roles.accountant} />
        <RoleRoute path="/accountant/requests/:id" exact component={RequestPage} props={childProps} role={roles.accountant} />
        
        {/* all roles (only authenticated) user routes */}
        <AuthenticatedRoute path="/devices" exact component={CertifiedDevices} props={childProps} />
        <AuthenticatedRoute path="/devices/:id" exact component={CertifiedDeviceView} props={childProps} />
        <AuthenticatedRoute path="/labs" exact component={TestLabs} props={childProps} />
        <AuthenticatedRoute path="/tools/fccid/:id" exact component={FCCID} props={childProps} />
        
        {/* test routes */}
        {/* <Route path="/test" exact component={Test} props={childProps} /> */}

        {/* 404 page */}
        <Route component={NotFound} />
    </Switch>;



// WEBPACK FOOTER //
// ./src/app/Routes.js